export default __webpack_public_path__ + "static/media/scion.9ba6c3a5.svg";